import AlertIcon from "../../static/icons/outlined/aviso.svg"
import { If } from "@mobi/components"

import "./TextMessage.scss"

interface IATextMessage {
  /** mensagem de erro */
  message?: string
  /** Define se a mensagem deve aparecer */
  show?: boolean
  /** Define ícone ilustrativo da mensagem */
  icon?: React.ElementType | string
  /** Define Id do elemento */
  id?: string
}

const TextMessage = ({
  message = "",
  show = true,
  icon: Icon = AlertIcon,
  ...props
}: IATextMessage) => {
  return (
    <If
      condition={show}
      renderIf={
        <p
          className="ds-text-message"
          aria-live="assertive"
          aria-atomic="true"
          {...props}
        >
          <Icon width={16} height={16} aria-hidden="true" /> {message}
        </p>
      }
      renderElse={<></>}
    />
  )
}

export default TextMessage
